<label
    class="btn btn-outline-secondary p-2 d-flex flex-column justify-content-center align-items-center"
    [ngClass]="{ 'disabled': isFull }"
    data-testid="reason-select"
>
    <div class="m-1 hstack gap-2 text-start">
        <input
            type="radio"
            class="form-check-input m-0"
            role="button"
            [value]="reason.id"
            [checked]="isSelected"
            [disabled]="isFull"
            (change)="reasonSelected.emit()"
        >
        <div class="vstack align-items-start">
            <div class="hstack gap-2 justify-content-between me-1">
                <div class="hstack gap-2">
                    <span class="fw-semibold">
                        {{ reason.displayName }}
                    </span>
                    @if (isFull) {
                        <span class="badge bg-dark-subtle text-dark-emphasis lh-sm me-auto fw-semibold">
                            {{ disabledLabel }}
                        </span>
                    }
                </div>
                <span class="small text-secondary">
                    {{ reason.displayedOpeningTimes !== null ? reason.displayedOpeningTimes : (reason | reasonTime : date) }}
                </span>
            </div>
            <div
                *ngIf="richTextPlainText(reason.description)"
                class="quill-flush"
                data-testid="booking-description"
            >
                <quill-view class="d-block" format="html" theme="bubble" [sanitize]="true" [id]="'reason-description-' + reason.id" [content]="
                    showMore
                        ? reason.description
                        : truncateRichTextHtml(reason.description ?? '', characterLimit)
                ">
                </quill-view>
                <button
                    *ngIf="richTextPlainText(reason.description).length > characterLimit"
                    class="btn btn-sm btn-link p-0 mt-1 lh-base text-start"
                    type="button"
                    [attr.aria-expanded]="showMore"
                    [attr.aria-controls]="'reason-description-' + reason.id"
                    (click)="showMore = !showMore"
                >
                    {{ showMore ? 'Read less' : 'Read more' }}
                </button>
            </div>
        </div>
    </div>
</label>
